<!-- <template>
    <div>
        <b-modal
            id="change-password-popup"
            ref="modal"
            title="Change Password"
            size="sm"
            hide-footer
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
            @shown="showModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="old-password-input"
                            label="Old Password"
                            label-for="old-password"
                        >
                            <b-form-input
                                id="old-password-field"
                                v-model="formData.oldPassword"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Enter old password"
                                data-vv-name="old password"
                                :class="{
                                    'is-invalid': errors.has('old password'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="new-password-input"
                            label="New Password"
                            label-for="new-password"
                        >
                            <b-form-input
                                id="new-password-field"
                                ref="password"
                                v-model="formData.password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Create new password"
                                :class="{
                                    'is-invalid': errors.has('new password'),
                                }"
                                name="new password"
                            ></b-form-input>
                            <div
                                class="system-user-warning password-validation"
                            >
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+      
                                    - Last 10 passwords cannot be reused."
                                ></i>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="confirm-password-input"
                            label="Confirm Password"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-password-field"
                                v-model="formData.passwordConfirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Re-enter new password"
                                data-vv-name="password confirmation"
                                :class="{
                                    'is-invalid': errors.has(
                                        'password confirmation'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        showModalProp: {
            type: Boolean,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        showModalProp(value) {
            if (value) {
                this.showModal()
            } else {
                this.hideModal()
            }
        },
        //hide Popup after success response
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showModal() {
            this.$refs.modal.show()
        }, // End of showModal() methods

        hideModal() {
            Object.assign(this.formData, this.initializeFormData())
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        }, // End of hideModal() methods

        initializeFormData() {
            return {
                oldPassword: '',
                password: '',
                passwordConfirmation: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            // let checkPassword = this.checkPassword(this.formData.password)
            if (result /*&& checkPassword*/) {
                try {
                    // authChangePassword action in auth store
                    let response = await this.$store.dispatch(
                        'authChangePassword',
                        this.formData
                    )
                    // Clearing formData fields and close popup on success response
                    if (response) {
                        this.clearFormData()
                        this.$refs.modal.hide()
                    }
                } catch (error) {
                    console.log(
                        error,
                        'There is an error on change submit password'
                    )
                }
            } else {
                let error = this.errors.all()[0]
                // if (!checkPassword && !error) {
                //     error =
                //         'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character'
                // }
                this.$store.commit('setError', error)
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
        // checkPassword(str) {
        //     // at least one number, one lowercase and one uppercase letter one special char
        //     // at least six characters
        //     var strongRegex = new RegExp(
        //         '/^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_+-])(?!.*\s).*$/'
        //     )

        //     return strongRegex.test(str)
        // },
    }, // End of Component > methods
}
</script> -->
<template>
    <div>
        <b-modal
            id="change-password-popup"
            ref="modal"
            title="Change Password"
            size="sm"
            hide-footer
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
            @shown="showModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="old-password-input"
                            label="Old Password"
                            label-for="old-password"
                        >
                            <b-form-input
                                id="old-password-field"
                                v-model="formData.oldPassword"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Enter old password"
                                data-vv-name="old password"
                                :class="{
                                    'is-invalid': errors.has('old password'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="new-password-input"
                            label="New Password"
                            label-for="new-password"
                        >
                            <b-form-input
                                id="new-password-field"
                                ref="password"
                                v-model="formData.password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Create new password"
                                :class="{
                                    'is-invalid': errors.has('new password'),
                                }"
                                name="new password"
                            ></b-form-input>
                            <div
                                class="system-user-warning password-validation"
                            >
                                <i
                                    v-b-tooltip.hover
                                    class="icon-error_outline"
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+      
                                    - Last 10 passwords cannot be reused."
                                ></i>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="confirm-password-input"
                            label="Confirm Password"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-password-field"
                                v-model="formData.passwordConfirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                type="password"
                                placeholder="Re-enter new password"
                                data-vv-name="password confirmation"
                                :class="{
                                    'is-invalid': errors.has(
                                        'password confirmation'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
        <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <otp-modal
                v-if="is_data_fetched"
                :data="otpData"
                heading="Two-Factor Authentication"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-modal>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OtpModal from '@/components/registration/OtpModal.vue'
import request from '@/utils/request'

export default {
    // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    components: {
        OtpModal,
    },

    props: {
        showModalProp: {
            type: Boolean,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            is_data_fetched: false,
            otpData: null,
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        showModalProp(value) {
            if (value) {
                this.showModal()
            } else {
                this.hideModal()
            }
        },
        //hide Popup after success response
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showModal() {
            this.$refs.modal.show()
        }, // End of showModal() methods

        hideModal() {
            Object.assign(this.formData, this.initializeFormData())
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        }, // End of hideModal() methods

        initializeFormData() {
            return {
                oldPassword: '',
                password: '',
                passwordConfirmation: '',
            }
        }, // End of initializeFormData() methods

        async sendOPT(value) {
            console.log('send otp call')
            try {
                let phoneNumber = value.phoneNumber
                let fullName = value.firstName
                let email = value.username
                this.$store.commit('setLoading', true)
                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: this.user.email,
                    emailText: true,
                }

                const { data } = await request({
                    url: `/configurations/generate-otp-auth/`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    this.is_data_fetched = true
                    data.data.phoneNumber = this.user.phoneNumber
                    this.otpData = data
                    this.$refs.otpmodal.show()
                }

                this.showPageLoader = false
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async reSendOTP() {
            await this.sendOPT(this.user)
        }, // End of reSendOTP() method

        async otpResponse(data) {
            if (data) {
                try {
                    this.$store.commit('setLoading', true)
                    this.formData.otpCode = data.otp
                    this.formData.token = data.token
                    //let encryptedForm = this.formData
                    let encryptedForm = this.CryptoJS.AES.encrypt(
                        JSON.stringify(this.formData),
                        process.env.VUE_APP_CSK
                    ).toString()
                    let response = await this.$store.dispatch(
                        'authChangePassword',
                        { data: encryptedForm }
                    )
                    console.log('response', response)

                    if (response.status === 200) {
                        this.clearFormData()
                        try {
                            let message =
                                'Your Password is changed successfully'
                            this.$store.commit('setSuccess', message)
                            setTimeout(async () => {
                                await this.$store.dispatch('authLogout')
                            }, 2000)
                            this.$store.commit('setLoading', false)
                            this.$refs.otpmodal.hide()
                        } catch (error) {
                            //console.log(error)
                        }
                        this.$refs.modal.hide()
                    } else if (response.status === 400) {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', response.data.message)
                        this.$refs.otpmodal.hide()
                    } else {
                        this.$store.commit(
                            'setError',
                            '' + response.data.message
                        )
                        this.$store.commit('setLoading', false)
                    }
                } catch (e) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', e)
                }
            } else {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', 'Could not get OTP')
            }
            // this.$store.commit('setLoading', false)
        }, // End of otpResponse() method

        async onSubmit() {
            console.log('on submit call')
            const result = await this.$validator.validateAll()
            // let checkPassword = this.checkPassword(this.formData.password)
            if (result /*&& checkPassword*/) {
                await this.sendOPT(this.user)
            } else {
                let error = this.errors.all()[0]
                // if (!checkPassword && !error) {
                //     error =
                //         'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character'
                // }
                this.$store.commit('setError', error)
            }
        }, // End of onSubmit() method

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        }, // End of clearFormData() method
        // checkPassword(str) {
        //     // at least one number, one lowercase and one uppercase letter one special char
        //     // at least six characters
        //     var strongRegex = new RegExp(
        //         '/^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_+-])(?!.*\s).*$/'
        //     )

        //     return strongRegex.test(str)
        // },
    }, // End of Component > methods
}
</script>
